export const commandsRootKey = ['commands']
export const commandsListKey = [...commandsRootKey, 'list']
